import { useParams } from 'react-router-dom';

import { ConnectedChargePointsTable } from 'features/charge-point/table';

export function OwnerChargePointsListPage() {
  const { ownerId } = useParams() as { ownerId: string };

  return <ConnectedChargePointsTable owner={ownerId} />;
}
